import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import LanguageTypes from '../../constants/LanguageTypes';
import WorkEnvironmentSections from '../../constants/WorkEnvironmentSections';
import Quadrant from './components/Quadrant';
import style from './style/workenvironment.scss';

class WorkEnvironment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            participantLanguage: null
        };

        this.setParticipantLanguage = this.setParticipantLanguage.bind(this);
    }

    componentDidUpdate() {
        const {participantLanguage} = this.props;

        if (participantLanguage && !this.state.participantLanguage) {
            this.setParticipantLanguage(participantLanguage);
        }
    }

    /**
     * setParticipantLanguage
     * converts language id to a shorthand notation that is used to import child components
     */
    setParticipantLanguage(participantLanguage) {
        this.setState({
            participantLanguage: participantLanguage.substr(0,2).toLowerCase()
        });
    }

    render() {
        const {workEnvironmentScores} = this.props;

        if (!workEnvironmentScores || !this.state.participantLanguage) {
            return null;
        }

        return (
            <section>
                <div className={style.work_environment_module_wrapper}>
                    <Quadrant score={workEnvironmentScores.filter(score => score.handle === WorkEnvironmentSections.MANAGER)[0]} language={this.state.participantLanguage}/>
                    <Quadrant score={workEnvironmentScores.filter(score => score.handle === WorkEnvironmentSections.TEAM)[0]} language={this.state.participantLanguage}/>
                    <Quadrant score={workEnvironmentScores.filter(score => score.handle === WorkEnvironmentSections.ORGANISATION)[0]} language={this.state.participantLanguage}/>
                </div>
            </section>
        );
    }
}

export default WorkEnvironment;

WorkEnvironment.propTypes = {
    participantLanguage: PropTypes.string.isRequired,
    workEnvironmentScores: PropTypes.array.isRequired
};
